<template>
  <div>
    <el-row type="flex" justify="space-between" v-show="percent === 100">
      <el-col :span="21"
        ><el-select
          v-model="item"
          filterable
          allow-create
          clearable
          default-first-option
          placeholder="Enter URL or Choose File"
          v-show="is_select"
        >
          <el-option-group
            v-for="group in assetOptions.filter((asset) =>
              accept.includes(asset.label)
            )"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="opt in group.options"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            >
              <i
                class="fas"
                :class="{
                  'fa-file-image': group.label.includes('image'),
                  'fa-file-video': group.label.includes('video'),
                }"
                style="padding: 0px 5px"
              ></i>
              <span> {{ opt.label }}</span>
              <span style="float: right; color: #8492a6" v-show="opt.compressed"
                >compressed</span
              >
            </el-option>
          </el-option-group>
        </el-select>
        <el-input
          v-model="item"
          prefix-icon="el-icon-edit"
          clearable
          placeholder="Enter URL or Choose File"
          v-show="!is_select"
        ></el-input
      ></el-col>
      <el-col :span="3">
        <el-upload
          action=""
          ref="upload"
          :accept="accept"
          :show-file-list="false"
          :before-upload="beforeUploadFile"
          :http-request="uploadFile"
          :on-change="handleChange"
        >
          <el-button><i class="el-icon-upload"></i></el-button>
        </el-upload>
      </el-col>
    </el-row>
    <el-progress :percentage="percent" v-show="percent < 100"></el-progress>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  props: {
    is_original: { type: Boolean, default: false },
    value: String,
    accept: {
      type: String,
      default: 'video/mp4, image/jpeg, image/png, application/zip',
    },
    check_upload_image_size: {
      default: function() {
        return {
          width: '',
          height: '',
          enable: false,
        };
      },
    },
    check_upload_image_ratio: {
      default: function() {
        return {
          width: '',
          height: '',
          enable: false,
        };
      },
    },
  },
  data() {
    return {
      percent: 100,
      fileList: [],
      item: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.item = newVal;

      if (
        !_.includes(this.fileUrls, newVal) &&
        _.includes(newVal, config.cdn_url) &&
        !_.includes(newVal, config.cdn_url + 'assets/')
      ) {
        this.$emit('input', '');
      }
    },
    item(newVal) {
      this.$emit('input', newVal);
    },
  },
  computed: {
    is_select() {
      return !this.item || _.includes(this.fileUrls, this.item);
    },
    ...mapState({
      fileUrls: (state) =>
        _.map(state.asset.assets, (asset) => asset.ffmpeg_url || asset.url),
      assetOptions: (state) =>
        _.map(
          [
            'video/mp4',
            'image/jpeg',
            'image/png',
            'image/gif',
            'application/zip',
            'application/x-zip-compressed',
            'application/zip-compressed',
          ],
          (mime_type) => ({
            label: mime_type,
            options: state.asset.assets
              .filter((i) => i.mime_type === mime_type)
              .map((i) => ({
                label: i.name,
                value: i.ffmpeg_url || i.url,
                compressed: i.ffmpeg_url,
              })),
          })
        ),
    }),
  },
  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeUploadFile(file) {
      // check file
      const is_type = this.accept
        .replaceAll(' ', '')
        .split(',')
        .includes(file.type);
      const is_lt_300mb = file.size < 1024 * 1024 * 300;
      const is_lt_4mb = file.size < 1024 * 1024 * 4;
      let is_pass_check_img_size = this.isPassCheckSize(file);
      if (!is_type) this.$message.error(`Please upload ${this.accept} file`);
      if (!is_lt_300mb) this.$message.error('File size must be < 300mb.');
      if (
        file.type === 'application/zip' ||
        file.type === 'application/x-zip-compressed' ||
        file.type === 'application/zip-compressed'
      ) {
        if (!is_lt_4mb) this.$message.error('File size must be < 4mb.');
        return is_type && is_lt_4mb;
      } else {
        return is_type && is_lt_300mb && is_pass_check_img_size;
      }
    },
    uploadFile(option) {
      const { file } = option;
      const raw_file = _.find(
        this.fileList,
        (raw_file) => raw_file.uid === file.uid
      ).raw;
      const formData = new FormData();
      formData.append('file', raw_file);
      formData.append('is_original', this.is_original);
      const reader = new FileReader();
      reader.onload = async (event) => {
        this.percent = 0;
        const config = {
          onUploadProgress: (event) => {
            this.percent = (event.loaded / event.total).toFixed(2) * 100;
          },
        };
        try {
          this.item = await store.dispatch('asset/createAsset', {
            formData,
            config,
          });
        } catch (e) {
          this.$message.error('Err! Please reupload file.');
        }
      };
      reader.readAsDataURL(file);
      this.$refs.upload.clearFiles();
      this.percent = 100;
    },
    isPassCheckSize(file) {
      if (this.check_upload_image_size.enable) {
        return this.checkImgSizeOnFile(file);
      } else if (this.check_upload_image_ratio.enable) {
        return this.checkImgSizeWithRatio(file);
      } else {
        return true;
      }
    },
    checkImgSizeOnFile(file) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        const vm = this;
        image.onload = function() {
          let inValid =
            this.width > vm.check_upload_image_size.width.max ||
            this.width < vm.check_upload_image_size.width.min ||
            this.height > vm.check_upload_image_size.height.max ||
            this.height < vm.check_upload_image_size.height.min;
          inValid ? reject() : resolve();
        };
        image.src = URL.createObjectURL(file);
      }).catch(() => {
        this.$message.error('please upload correct size file');
        return Promise.reject();
      });
    },
    checkImgSizeWithRatio(file) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        const vm = this;
        image.onload = function() {
          let sizeWidth = vm.check_upload_image_ratio.width;
          let sizeHeight = vm.check_upload_image_ratio.height;
          if (typeof sizeWidth === 'object') {
            sizeWidth = sizeWidth.min;
          }
          if (typeof sizeHeight === 'object') {
            sizeHeight = sizeHeight.min;
          }
          let widthRatio = this.width / sizeWidth;
          let heightRatio = this.height / sizeHeight;
          widthRatio === heightRatio ? resolve() : reject();
        };
        image.src = URL.createObjectURL(file);
      }).catch(() => {
        this.$message.error('please upload correct ratio file');
        return Promise.reject();
      });
    },
  },
};
</script>

<style></style>
